import React from "react";
/* Import Boostrap */
import { connect } from 'react-redux';
import { getTranslate } from 'react-localize-redux';

const ContainerWidget = ({ translate, props }) => {
    return (
        <div className="gtco-widget">
            {props.children}
        </div>
    )
}

const mapStateToProps = (state, ownProps) => {
  return {
    translate: getTranslate(state.locale),
    props: ownProps
  };
};

export default connect(mapStateToProps)(ContainerWidget);


// WEBPACK FOOTER //
// ./src/components/containers/container-widget.jsx